import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GritCoreModule } from '@progleasing/grit-core';
import { PgAppFormTemplateComponent } from './pg-app-form-template.component';
import { PgProjectableDirective } from './projectable';
import {
  PgAppFormSectionComponent,
  PgAppFormPageActionComponent,
  PgAppFormSectionTitleComponent,
  PgAppFormPageComponent,
  PgAppFormPageBodyComponent,
  PgAppFormPageTitleComponent,
  PgAppFormHeaderComponent,
  PgAppFormFooterComponent,
} from './pg-app-form-blocks';

@NgModule({
  imports: [CommonModule, GritCoreModule],
  declarations: [
    PgAppFormTemplateComponent,

    PgProjectableDirective,
    PgAppFormSectionComponent,
    PgAppFormPageActionComponent,
    PgAppFormSectionTitleComponent,
    PgAppFormPageComponent,
    PgAppFormPageBodyComponent,
    PgAppFormPageTitleComponent,
    PgAppFormHeaderComponent,
    PgAppFormFooterComponent,
  ],
  exports: [
    PgAppFormTemplateComponent,

    PgProjectableDirective,
    PgAppFormSectionComponent,
    PgAppFormPageActionComponent,
    PgAppFormSectionTitleComponent,
    PgAppFormPageComponent,
    PgAppFormPageBodyComponent,
    PgAppFormPageTitleComponent,
    PgAppFormHeaderComponent,
    PgAppFormFooterComponent,
  ],
  providers: [],
})
export class GritOriginationTemplateModule {}
